"use client";

import { AnimatedList } from "@/components/componentAnimation/animatedListComponent";
import sharedStyles from "../shared/SectionTitle.module.css";
import styles from "./AccommodationOptionsSection.module.css";
import type { AccommodationItem } from "@/app/student-life/accommodation/types";
import AccommodationCard from "../AccommodationCard/AccommodationCard";

type AccommodationOptionsSectionProps = {
  items: AccommodationItem[];
  onViewDetail: (item: AccommodationItem) => void;
  sectionTitle: string;
  viewDetailLabel: string;
};

export default function AccommodationOptionsSection({
  items,
  onViewDetail,
  sectionTitle,
  viewDetailLabel,
}: AccommodationOptionsSectionProps) {
  return (
    <section className={styles.optionsSection}>
      <h2 className={sharedStyles.sectionTitle}>{sectionTitle}</h2>

      <AnimatedList isHorizontal={false} className={styles.optionsGrid}>
        {items.map((item) => (
          <AccommodationCard
            key={item.id}
            item={item}
            onViewDetail={onViewDetail}
            viewDetailLabel={viewDetailLabel}
          />
        ))}
      </AnimatedList>
    </section>
  );
}
